interface IDecorateParams {
  banners: any;
  additionalParams: {
    [key: string]: string | string[];
  }[];
}

export const decorateBannersForAds = ({ banners, additionalParams = [] }: IDecorateParams) => {
  return Object.keys(banners).reduce((res, key) => {
    const newKey = key;

    res[newKey] = banners[key];

    // for google
    if (res[newKey]?.targeting?.dfp) {
      decorateBanner(res[newKey].targeting.dfp, additionalParams);
    }

    // for yandex
    if (res[newKey]?.params) {
      decorateBanner(res[newKey].params, additionalParams);
    }

    return res;
  }, {});
};

const decorateBanner = (targetObj, additionalParams) => {
  if (!additionalParams.length) return;

  additionalParams.forEach((param) => {
    const [[key, value]] = Object.entries(param);
    if (key && value) targetObj[(key as unknown) as string] = value;
  });
};
